import { createContext } from 'react';
import type { ReviewContextType } from './ReviewContext';

export const ReviewContext = createContext<ReviewContextType | undefined>(undefined);
